import React, { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { Box, SxProps, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default observer(function MainMenuControl({
  children,
  onClick,
  sx,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  sx?: SxProps;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const theme = useTheme();

  return (
    <Box
      sx={{
        'display': 'flex',
        'gap': defaultSpacingPresets.sp.s20,
        'alignItems': 'center',
        'cursor': 'pointer',
        'width': 1,
        'color': theme.palette.custom.textInactive,

        '&:hover': {
          'color': theme.palette.primary.main,

          '& .icon': {
            fill: theme.palette.primary.main,
          },
        },
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
});
